// @flow
import type {
  User,
  UsersById,
} from 'fc-model-users/types'

// Selectors
import { users$ } from 'fc-users'
import authenticatedUserId$ from './authenticatedUserId'

// Utils
import emptyObjectOr from 'fc-utils/emptyObjectOr'
import traverse from 'fc-utils/traverse'

// Exports
export default (state: {}): ?User => {
  const users: UsersById = users$(state)
  const userId: ?number = authenticatedUserId$(state)

  return emptyObjectOr(traverse([userId])(users))
}
